import { apiConstants } from '../constants/apiConstants'
import caller from '../caller'
import serverData from '../utils/server-data'

function getHttpRequestMethod(method) {
  if (method === 'POST') {
    return 'sendPostRequest'
  }
  if (method === 'PUT') {
    return 'sendPutRequest'
  }
  if (method === 'PATCH') {
    return 'sendPatchRequest'
  }
  if (method === 'DELETE') {
    return 'sendDeleteRequest'
  }
  return 'sendGetRequest'
}

function getURL(filePath, apiSuffix, isNewURLPattern = false) {
  const user = serverData.user
  const URLPrefix = `${apiConstants.URLPrefix}/${user.accType}/${user.username}`
  if (isNewURLPattern) {
    /* Applicable for share permission request API's */
    return `${URLPrefix}${apiSuffix}/${filePath}`
  }
  if (filePath === '') {
    return `${URLPrefix}${apiSuffix}`
  }
  if (apiSuffix === '') {
    return `${URLPrefix}/path/${filePath}`
  }
  return `${URLPrefix}/path/${filePath}${apiSuffix}`
}

export function httpRequest(
  method,
  filePath,
  apiSuffix,
  params,
  isNewURLPattern = false,
) {
  const url = getURL(filePath, apiSuffix, isNewURLPattern)
  return caller[getHttpRequestMethod(method)](url, params)
    .then((response) => {
      return response
    })
    .catch((err) => {
      return err
    })
}

export default { httpRequest }
